import React, { useEffect, useState } from "react";

import { Button, Modal } from "react-bootstrap";

interface ConfirmComponentParams {
  bodyNode: React.ReactNode;
  confirmLabel: string;
  closeLabel: string;
  onConfirm: () => void;
  onClose: () => void;
  onHide: () => void;
  show: boolean;
}

const ConfirmComponent = ({
  bodyNode,
  confirmLabel,
  closeLabel,
  onConfirm,
  onClose,
  onHide,
  show,
}: ConfirmComponentParams) => {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    setShowModal(show);
  }, [show]);

  const handleConfirm = () => {
    setShowModal(false);
    onConfirm();
  };

  const handleClose = () => {
    setShowModal(false);
    onClose();
  };

  const handleHide = () => {
    setShowModal(false);
    onHide();
  };

  return (
    <Modal
      centered
      className="confirmModalContainer"
      onHide={() => handleHide()}
      show={showModal}
    >
      <Modal.Dialog>
        <Modal.Header closeButton />
        <Modal.Body>{bodyNode}</Modal.Body>

        <Modal.Footer>
          <Button
            className="p-2"
            onClick={() => handleClose()}
            variant="outline-primary"
          >
            {confirmLabel}
          </Button>
          <Button
            className="p-2"
            onClick={() => handleConfirm()}
            variant="primary"
          >
            {closeLabel}
          </Button>
        </Modal.Footer>
      </Modal.Dialog>
    </Modal>
  );
};

export default ConfirmComponent;
